const Footer = () => {
  return <>
    <footer className="footer py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-12">                                
              <p className="copyright-text text-center">Copyright &copy; 2022 Louis Mary MONJENGUE . All rights reserved</p>
          </div>
        </div>
      </div>
    </footer>
  
  </>;
}

export default Footer;